import BaseModel from "../default/base-model";

export class ProjectType extends BaseModel {
    id?: number;
    name: string;
    in_use?: boolean;

    constructor() {
        super();
        this.id = undefined;
        this.name = "";
    }
}

export enum CalendarType {
    CHINA = "CHINA",
    MANAUS = "MANAUS",
    SAO_PAULO = "SAO_PAULO"
}

export const calendarTypeLabels: Record<CalendarType, string> = {
    [CalendarType.CHINA]: "CHINA",
    [CalendarType.MANAUS]: "MANAUS",
    [CalendarType.SAO_PAULO]: "SÃO PAULO",
};

export class Calendar extends BaseModel {
    id?: number;
    type: CalendarType;

    constructor() {
        super();
        this.id = undefined;
        this.type = CalendarType.CHINA;
    }
}

export class Template extends BaseModel {
    id?: number;
    name: string;
    project_type: number | "";
    copy_template?: number | "";
    calendars: number[];
    amount_of_days: number;
    active: boolean;
    prazo_total: number;
    qtde_etapas: number;
    qtde_atividades: number;
    groups: TemplateGroup[];
    in_use?: boolean;

    constructor() {
        super();
        this.id = undefined;
        this.name = "";
        this.project_type = "";
        this.copy_template = "";
        this.calendars = [];
        this.amount_of_days = 0;
        this.active = true;
        this.prazo_total = 0;
        this.qtde_etapas = 0;
        this.qtde_atividades = 0;
        this.groups = [];
    }
}

export interface TemplateTask {
    id: number;
    name: string;
    acronym: string;
    status: string;
    resource: CalendarType | "";
    duration: number;
    predecessor?: number | number[] | "" | null;
}

export interface TemplateGroup {
    id: number;
    name: string;
    ancestor_group?: number | null;
    order?: number;
    tasks: TemplateTask[];
}
